// --------------------------------------------------
//  スクロール出現アニメ発火 (issue #163, #32)
//
//  [data-scroll-reveal] が付いた要素を IntersectionObserver で監視し、
//  viewport に入った瞬間に `is-visible` を付与する (= SCSS 側で paused → running)。
//  発火後は unobserve して二度目以降は監視しない (1 度きりの演出)。
//
//  team の members-item 専用実装 (team-members-animation.js) を、
//  sponsors ページ追加にあわせて data 属性ベースの汎用実装に置き換えたもの。
//  対象を増やしたいときは要素に data-scroll-reveal を付け、
//  SCSS 側に `.js .<block>` スコープの paused アニメ + `.is-visible` で
//  running にする規則を書けばよい (この JS は触らなくてよい)。
//
//  - reduce-motion 環境では即時 is-visible を全要素に付与してアニメ短縮。
//  - JS 自体は <html class="js"> が付いている前提なので、NoJS 環境では
//    SCSS 側の `.js` スコープが効かず、要素は素のまま表示される。
// --------------------------------------------------

const init = () => {
  const items = document.querySelectorAll('[data-scroll-reveal]');
  if (items.length === 0) return;

  // talks/_talk.scss が 2 カラムへ切り替わる lg と同じ境目。
  // 詳細ページの話者カードは、2 カラムならページ全体のタイムラインに乗せ、
  // 1 カラムならスクロールして来た時に発火させる。
  const wideLayout = window.matchMedia('(min-width: 64rem)');

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    },
    {
      // 下端から少し奥まで見えたら発火 (上端側はそのまま、画面下からの登場で発火)
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    }
  );

  items.forEach((el) => {
    if (el.hasAttribute('data-scroll-reveal-wide-immediate') && wideLayout.matches) {
      el.classList.add('is-visible');
      return;
    }

    observer.observe(el);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
